
<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <EventTimeLine :timeIndex="status"></EventTimeLine>
      </zj-layout-header>
      <zj-layout-main>
          <EventInfo
            :EventConfirm="EventConfirm"
            :EventInfoEdit="EventInfoEdit"
            :EventSourceEdit="EventSourceEdit"
            :EventAffectEdit="EventAffectEdit"
            :IsReport="IsReport"
            :EventConfirmEdit="EventConfirmEdit"
            :editable="editable"
          ></EventInfo>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import EventTimeLine from "./EventTimeLine.vue";
import EventInfo from "./EventInfo.vue";
export default {
  name: "ZjReportEvent",
  controller: "UI",
  action: "ReportEvent",
  components: {
    EventTimeLine,
    EventInfo
  },
  data() {
    return {
      status: 2,
      EventInfoEdit: true,
      EventSourceEdit: true,
      EventAffectEdit: true,
      EventConfirmEdit: true,
      IsReport:true,
      editable:true
    };
  }
};
</script>